module.exports = __webpack_public_path__ + "img/depositphotos_7800131-stock-photo-business-man.f35dd738.jpg";